import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()
// スムーズスクロールの補正要素
const scrollAdjust = '#header'
// const scrollAdjust = 0  //スムーズスクロールの補正要素

// アンカーをクリックしたらスクロール
const anchorLinks = document.querySelectorAll('a[href*="#"]:not(.no-move):not([target="_blank"])')
for (let index = 0; index < anchorLinks.length; index++) {
  const anchorLink = anchorLinks[index]
  anchorLink.addEventListener(
    'click',
    function() {
      event.preventDefault()
      const href = this.getAttribute('href').replace(/.*#/gi, '#') // 同一ページならハッシュ以外を削ってページ遷移を抑止
      autoScroll(href, scrollAdjust)
    },
    false
  )
}

// アクセス時にハッシュがある場合はスクロール
if (location.hash) {
  window.setTimeout(() => {
    autoScroll(location.hash, scrollAdjust, false)
  }, 100)
}

/**
 * 指定されたセレクタに向かってスクロールを行う
 *
 * @function autoScroll
 * @param  {String} point  移動先のセレクタ
 * @param  {String|Number} adjust 追従ヘッダーの高さを加算し、移動先にヘッダーがかぶらないようにする。ヘッダーのセレクタもしくは数値を入れる
 * @param  {Boolean} [anime=true]  アニメーションの有無
 * @return {Boolean} false
 */

function autoScroll(point, adjust = 0, anime = true) {
  const nowPosition = window.pageYOffset
  if (isNaN(adjust)) {
    // 数値以外なら要素として高さ取得
    adjust = document.querySelector(adjust).offsetHeight
  }
  const target = document.querySelector(point === '#' || point === '' ? 'html' : point)
  if (target) {
    // ターゲットを検出したら実行
    const goto = nowPosition + target.getBoundingClientRect().top - adjust
    let behavior = 'instant'
    if (anime) {
      behavior = 'smooth'
    }
    window.scrollTo({
      top: goto,
      behavior: behavior
    })
  }
}
